export const BOOKING_PROFILE_PATH = "/booking-profile";